import { useState as s, useEffect as H } from "react";
import { useScreenZoom as W } from "./index.es530.js";
const x = ({
  cards: t,
  cardType: c
}) => {
  const { zoomPercentage: g } = W(), h = g >= 200, [m, a] = s(0), [f, l] = s(0);
  return H(() => {
    if (!t || t.length === 0)
      return;
    let e = 0, i = 0;
    t.forEach((u) => {
      var r;
      const C = u.id, o = (r = document.getElementById(C)) == null ? void 0 : r.firstChild;
      if (o) {
        const n = o.clientWidth, d = o.clientHeight;
        n > e && (e = n), d > i && (i = d);
      }
    }), l(i), a(e);
  }, [t, c]), { isZoomed: h, biggestCardWidth: m, biggestCardHeight: f };
};
export {
  x as useCardGrid
};
//# sourceMappingURL=index.es695.js.map
